import { useEffect } from 'react'

export const useMountEffect = effect => useEffect(effect, [])
export const useUnmountEffect = effect => useEffect(() => effect, [])
export const useChillEffect = (effect, dependencies = []) => useEffect(effect, dependencies)
